import { Component, Inject, Input, OnDestroy } from "@angular/core";

import { OnInit } from "@angular/core";

import { FieldGeneratorService } from "../../services/field-generator.service";
import { MatDialog, fadeInItems } from "@angular/material";

import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { MessageService } from '../../services/message.service';
import { EventBusService } from '../../services/event-bus.service';
import { GlobalCfgService } from '../../services/globalcfg.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { ConfirmationDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: "rm-manage-role",
  templateUrl: "./manage-role.component.html",
  styleUrls: ["./manage-role.component.css"]
})
export class ManageRoleComponent implements OnInit, OnDestroy {
  hideToolbar: boolean = false;
  
  columns: any[] = [
    { name: "description", displayName: "Description"},
    { name: "name", displayName: "Name" },
    { name: "created", displayName: "Created On", type: 'date', format: "DD/MM/YYYY" },
    { name: "userCnt", displayName: "No. of Users" },
    { name: "actions", type: "actions", displayName: ""}
  ];
  subscriptions: any[] = [];
  roles: any[] = [];
  role: any;
  totalCount: number = 0;

  constructor(
    private dialog: MatDialog,
    private fgService: FieldGeneratorService,
    private authService: AuthService,
    private ebService: EventBusService,
    private msgService: MessageService,
    private globalCfgService: GlobalCfgService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.ebService.hideGcpChangeSource.next();

    this.route.parent.url.subscribe(url => {
      //always the first part is role
      this.role = url.values().next().value.path;
    });
    this.loadRoles();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  
  loadRoles() {
    this.authService.getRoles().subscribe(
      (result: any)=> {
        this.roles = result;
        this.totalCount = result.length;

        //add actions
        this.roles.forEach(r => {
          r['actions'] = [
            {name: 'edit', tip: 'Edit'}
          ];

          if (!r.userCnt) {
            r['actions'].push({name: 'delete', tip: 'Delete'});
          }
        });
      }
    );
  }

  add() {
    var fields = this.fgService.getFields(
      [
        { name: "name", displayName: "Name" },
        { name: "description", displayName: "Description" }
      ],null
    );
    const dialogRef = this.dialog.open(FormDialogComponent, {
      width: "450px",
      data: { 
        title: "Add Role", 
        fields: fields },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      if(!result) {
        return;
      }
      this.authService
        .addRole(result)
        .subscribe(
          (response: any[]) => {
            console.log("Role added");
            this.msgService.showSuccess(this.msgService.roleCreate);
            this.loadRoles();
          },
          error => {
            console.log("Service error:");
          }
        );
    });
  }

  onActionClicked(e) {
    console.log("onActionClicked: ", e);
    var rec = e.record;
    switch (e.actionName.name) {
      case "edit":
        var fields = this.fgService.getFields(
          [
            { name: "name", displayName: "Name" },
            { name: "description", displayName: "Description" }
          ],
          rec
        );
        const dialogRef = this.dialog.open(FormDialogComponent, {
          width: "450px",
          data: { 
            title: "Edit Role", 
            fields: fields,
            note: 'Updating name is ignored if the role has users. Contact support team for that.' },
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log("The dialog was closed", result);

          var name = rec.name;
          if (!rec.userCnt) {
            name = result.name;
          }

          this.authService
            .updateRole(rec.id, name, result.description)
            .subscribe(
              (response: any[]) => {
                console.log("Role edited");
                this.msgService.showSuccess(this.msgService.roleUpdate);
                this.loadRoles();
              },
              error => {
                console.log("Service error:");
              }
            );
        });
        break;
        case "delete":
          const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
            width: '450px',
            data: {
                message: 'Are you sure you want to delete the role?'
            }
          });
  
          dialogRef1.afterClosed().subscribe(
            (result) => {
              if (result == 'yes') {
                  this.authService.deleteRole(rec.id).subscribe(
                      () => {
                          this.msgService.showSuccess(this.msgService.roleDelete);
                          this.loadRoles();
                      }
                  );
              }
          });
          break;
      default:
        console.log("Unhandled action: ", e.actionName);
    }
  }
}
